// extracted by mini-css-extract-plugin
export default {"Small":"style_Small__ghb5O","unchecked":"style_unchecked__4diX7","checked":"style_checked__mbMLy","indeterminate":"style_indeterminate__+sWci","disabled":"style_disabled__PWekj"};